export const HTTP_HEADERS = {
  DEVICE_ID: 'X-Device-ID',
};
